/** @format */
import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { IAvailabilityData, IAvailabilityMessage } from './availability-messaging.interface';
import { PICKUP_MESSAGES, SHIPPING_MESSAGES } from './availability-messaging.constants';

@Component({
  selector: 'homefield-availability',
  templateUrl: './shared-product-availability.component.html',
  styleUrl: './shared-product-availability.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldAvailabilityComponent implements OnChanges {
  @Input() isComingSoon = false;
  @Input() isOOS = false;
  @Input() productAvailabilityData: IAvailabilityData | undefined = undefined;
  @Input() selectedStoreId = '';

  pickupMessage: IAvailabilityMessage | undefined = undefined;
  shippingMessage: IAvailabilityMessage | undefined = undefined;

  ngOnChanges(): void {
    if (this.productAvailabilityData) {
      this.shippingMessage = SHIPPING_MESSAGES[this.productAvailabilityData.onlineInventoryMessage];
      this.pickupMessage = PICKUP_MESSAGES[this.productAvailabilityData.inStoreInventoryMessage];
    }
  }
}
